import RsaRiepiloghiPage from "./pages/RsaRiepiloghiPage.vue";
import RsaRiepilogoVociDiarioListPage from "./pages/RsaRiepilogoVociDiarioListPage.vue";


export default {    RsaRiepiloghiPage, RsaRiepilogoVociDiarioListPage
};